import {
    createLead,
    createLeadNotAuth,
    createLeadReferral,
    getListLead,
    getReportByLeads,
    getActivatePromotionalCodeRequest,
    getTechAbility,
} from '~/src/repositories/lead/lead.repository';

export const LeadService = {
    createLead,
    createLeadReferral,
    createLeadNotAuth,
    getListLead,
    getReportByLeads,
    getActivatePromotionalCodeRequest,
    getTechAbility,
};
